import { slugify } from "../../../../utils/slugifyString";

export const getDepartement = (searchState) => {
  const data = [
    { num: "01", label: "AIN", longitude: 5.349, latitude: 46.0994 },
    { num: "02", label: "AISNE", longitude: 3.5583, latitude: 49.5594 },
    { num: "03", label: "ALLIER", longitude: 3.1883, latitude: 46.3936 },
    {
      num: "04",
      label: "ALPES-DE-HAUTE-PROVENCE",
      longitude: 6.2439,
      latitude: 44.1061,
    },
    { num: "05", label: "HAUTES-ALPES", longitude: 6.2631, latitude: 44.6636 },
    {
      num: "06",
      label: "ALPES-MARITIMES",
      longitude: 7.1164,
      latitude: 43.9375,
    },
    { num: "07", label: "ARDECHE", longitude: 4.4247, latitude: 44.7517 },
    { num: "08", label: "ARDENNES", longitude: 4.6408, latitude: 49.6156 },
    { num: "09", label: "ARIEGE", longitude: 1.4706, latitude: 42.9208 },
    { num: "10", label: "AUBE", longitude: 4.1617, latitude: 48.3044 },
    { num: "11", label: "AUDE", longitude: 2.4142, latitude: 43.1033 },
    { num: "12", label: "AVEYRON", longitude: 2.6797, latitude: 44.2803 },
    {
      num: "13",
      label: "BOUCHES-DU-RHONE",
      longitude: 5.0864,
      latitude: 43.5433,
    },
    { num: "14", label: "CALVADOS", longitude: -0.3636, latitude: 49.0997 },
    { num: "15", label: "CANTAL", longitude: 2.6686, latitude: 45.0511 },
    { num: "16", label: "CHARENTE", longitude: 0.2017, latitude: 45.7178 },
    {
      num: "17",
      label: "CHARENTE-MARITIME",
      longitude: -0.6744,
      latitude: 45.7819,
    },
    { num: "18", label: "CHER", longitude: 2.4911, latitude: 47.0647 },
    { num: "19", label: "CORREZE", longitude: 1.8772, latitude: 45.3572 },
    { num: "2A", label: "CORSE-DU-SUD", longitude: 8.9881, latitude: 41.8636 },
    { num: "2B", label: "HAUTE-CORSE", longitude: 9.2064, latitude: 42.3942 },
    { num: "21", label: "COTE-D'OR", longitude: 4.7722, latitude: 47.4247 },
    {
      num: "22",
      label: "COTES-D'ARMOR",
      longitude: -2.8642,
      latitude: 48.4411,
    },
    { num: "23", label: "CREUSE", longitude: 2.0189, latitude: 46.0903 },
    { num: "24", label: "DORDOGNE", longitude: 0.7414, latitude: 45.1042 },
    { num: "25", label: "DOUBS", longitude: 6.3617, latitude: 47.1653 },
    { num: "26", label: "DROME", longitude: 5.1681, latitude: 44.6842 },
    { num: "27", label: "EURE", longitude: 0.9961, latitude: 49.1136 },
    { num: "28", label: "EURE-ET-LOIR", longitude: 1.3703, latitude: 48.3875 },
    { num: "29", label: "FINISTERE", longitude: -4.0589, latitude: 48.2611 },
    { num: "30", label: "GARD", longitude: 4.1803, latitude: 43.9933 },
    { num: "31", label: "HAUTE-GARONNE", longitude: 1.1728, latitude: 43.3586 },
    { num: "32", label: "GERS", longitude: 0.4533, latitude: 43.6928 },
    { num: "33", label: "GIRONDE", longitude: -0.5753, latitude: 44.8253 },
    { num: "34", label: "HERAULT", longitude: 3.3672, latitude: 43.5797 },
    {
      num: "35",
      label: "ILLE-ET-VILAINE",
      longitude: -1.6386,
      latitude: 48.1544,
    },
    { num: "36", label: "INDRE", longitude: 1.5758, latitude: 46.7778 },
    {
      num: "37",
      label: "INDRE-ET-LOIRE",
      longitude: 0.6914,
      latitude: 47.2581,
    },
    { num: "38", label: "ISERE", longitude: 5.5761, latitude: 45.2633 },
    { num: "39", label: "JURA", longitude: 5.6978, latitude: 46.7283 },
    { num: "40", label: "LANDES", longitude: -0.7839, latitude: 43.9656 },
    { num: "41", label: "LOIR-ET-CHER", longitude: 1.4294, latitude: 47.6167 },
    { num: "42", label: "LOIRE", longitude: 4.1658, latitude: 45.7272 },
    { num: "43", label: "HAUTE-LOIRE", longitude: 3.8064, latitude: 45.1281 },
    {
      num: "44",
      label: "LOIRE-ATLANTIQUE",
      longitude: -1.6822,
      latitude: 47.3614,
    },
    { num: "45", label: "LOIRET", longitude: 2.3442, latitude: 47.9128 },
    { num: "46", label: "LOT", longitude: 1.6047, latitude: 44.6242 },
    {
      num: "47",
      label: "LOT-ET-GARONNE",
      longitude: 0.4603,
      latitude: 44.3675,
    },
    { num: "48", label: "LOZERE", longitude: 3.5003, latitude: 44.5172 },
    {
      num: "49",
      label: "MAINE-ET-LOIRE",
      longitude: -0.5642,
      latitude: 47.3908,
    },
    { num: "50", label: "MANCHE", longitude: -1.3275, latitude: 49.0794 },
    { num: "51", label: "MARNE", longitude: 4.2386, latitude: 48.9492 },
    { num: "52", label: "HAUTE-MARNE", longitude: 5.2264, latitude: 48.1094 },
    { num: "53", label: "MAYENNE", longitude: -0.6581, latitude: 48.1467 },
    {
      num: "54",
      label: "MEURTHE-ET-MOSELLE",
      longitude: 6.165,
      latitude: 48.7869,
    },
    { num: "55", label: "MEUSE", longitude: 5.3817, latitude: 48.9894 },
    { num: "56", label: "MORBIHAN", longitude: -2.81, latitude: 47.8464 },
    { num: "57", label: "MOSELLE", longitude: 6.6633, latitude: 49.0372 },
    { num: "58", label: "NIEVRE", longitude: 3.5047, latitude: 47.1153 },
    { num: "59", label: "NORD", longitude: 3.2206, latitude: 50.4472 },
    { num: "60", label: "OISE", longitude: 2.4253, latitude: 49.4103 },
    { num: "61", label: "ORNE", longitude: 0.1289, latitude: 48.6236 },
    { num: "62", label: "PAS-DE-CALAIS", longitude: 2.2886, latitude: 50.4936 },
    { num: "63", label: "PUY-DE-DOME", longitude: 3.1408, latitude: 45.7258 },
    {
      num: "64",
      label: "PYRENEES-ATLANTIQUES",
      longitude: -0.7614,
      latitude: 43.2567,
    },
    {
      num: "65",
      label: "HAUTES-PYRENEES",
      longitude: 0.1639,
      latitude: 43.0531,
    },
    {
      num: "66",
      label: "PYRENEES-ORIENTALES",
      longitude: 2.5222,
      latitude: 42.6,
    },
    { num: "67", label: "BAS-RHIN", longitude: 7.5514, latitude: 48.6708 },
    { num: "68", label: "HAUT-RHIN", longitude: 7.2742, latitude: 47.8586 },
    { num: "69", label: "RHONE", longitude: 4.6414, latitude: 45.8703 },
    { num: "70", label: "HAUTE-SAONE", longitude: 6.0861, latitude: 47.6417 },
    {
      num: "71",
      label: "SAONE-ET-LOIRE",
      longitude: 4.5422,
      latitude: 46.6447,
    },
    { num: "72", label: "SARTHE", longitude: 0.2222, latitude: 47.9944 },
    { num: "73", label: "SAVOIE", longitude: 6.4436, latitude: 45.4775 },
    { num: "74", label: "HAUTE-SAVOIE", longitude: 6.4281, latitude: 46.0344 },
    { num: "75", label: "PARIS", longitude: 2.3422, latitude: 48.8567 },
    { num: "76", label: "SEINE-MARITIME", longitude: 1.0264, latitude: 49.655 },
    {
      num: "77",
      label: "SEINE-ET-MARNE",
      longitude: 2.9333,
      latitude: 48.6267,
    },
    { num: "78", label: "YVELINES", longitude: 1.8417, latitude: 48.815 },
    { num: "79", label: "DEUX-SEVRES", longitude: -0.3172, latitude: 46.5556 },
    { num: "80", label: "SOMME", longitude: 2.2778, latitude: 49.9581 },
    { num: "81", label: "TARN", longitude: 2.1661, latitude: 43.7853 },
    {
      num: "82",
      label: "TARN-ET-GARONNE",
      longitude: 1.2819,
      latitude: 44.0858,
    },
    { num: "83", label: "VAR", longitude: 6.2181, latitude: 43.4606 },
    { num: "84", label: "VAUCLUSE", longitude: 5.1861, latitude: 43.9939 },
    { num: "85", label: "VENDEE", longitude: -1.2978, latitude: 46.6747 },
    { num: "86", label: "VIENNE", longitude: 0.4603, latitude: 46.5639 },
    { num: "87", label: "HAUTE-VIENNE", longitude: 1.2353, latitude: 45.8917 },
    { num: "88", label: "VOSGES", longitude: 6.3806, latitude: 48.1967 },
    { num: "89", label: "YONNE", longitude: 3.5644, latitude: 47.8397 },
    {
      num: "90",
      label: "TERRITOIRE DE BELFORT",
      longitude: 6.9286,
      latitude: 47.6317,
    },
    { num: "91", label: "ESSONNE", longitude: 2.2431, latitude: 48.5222 },
    {
      num: "92",
      label: "HAUTS-DE-SEINE",
      longitude: 2.2458,
      latitude: 48.8472,
    },
    {
      num: "93",
      label: "SEINE-SAINT-DENIS",
      longitude: 2.4781,
      latitude: 48.9175,
    },
    { num: "94", label: "VAL-DE-MARNE", longitude: 2.4689, latitude: 48.7775 },
    { num: "95", label: "VAL-D'OISE", longitude: 2.1311, latitude: 49.0828 },
  ];
  let results = [];
  if (searchState?.length > 1) {
    results = data
      .filter((departement) => {
        if (
          slugify(departement.label).includes(slugify(searchState)) ||
          departement.num.includes(slugify(searchState))
        ) {
          return departement;
        }
      })
      .map((departement) => {
        return {
          geometry: {
            coordinates: [departement.longitude, departement.latitude],
          },
          properties: {
            id: slugify(departement.label),
            label: departement.label,
            type: "departement",
          },
        };
      });

    if (results?.length > 3) {
      results = results.slice(2);
    }
  }

  return results;
};
